export enum TopAreaMiddleButtonTypes {
  unset = 'unset',
  ShowPromotionsCommand = 'promotions',
  ShowCouponsCommand = 'coupons',
  ShowGiftCardsCommand = 'giftCard',
}
